module.exports = "/src/views/player/help/images/mws2.jpg";